/* eslint-disable camelcase */
import { format } from 'date-fns';
import { eo } from 'date-fns/esm/locale';
import _round from 'lodash/round';
import _orderBy from 'lodash/orderBy';
import { getFormatDate } from 'util/formattedDate';
import { getNumbersOfString } from 'util/strings';

export const transformReviews = (data) => {
  const transformedReviews = data.map((item) => {
    let createdDate = '';
    const string = getFormatDate(item.date_created);

    const eventDate = new Date(`${string} 00:00:00`);
    const formattedEventDate = format(eventDate, 'dd/MM/yyyy', {
      locale: eo,
    });
    createdDate = formattedEventDate.toUpperCase();

    const dataReview = {
      ...item,
      description: item.review,
      title: item.title,
      name: item.customer_name,
      date: createdDate,
      rating: item.rating,
    };
    return dataReview;
  });

  return transformedReviews;
};

export const transformStats = (stats) => {
  const { score, total_review } = stats;

  const filterRatings = ([key]) => key !== 'score' && key !== 'total_review';

  const mapRatings = ([key, value]) => {
    const percentage = value > 0 ? parseInt((value / total_review) * 100, 10) : 0;
    return {
      rating: getNumbersOfString(key),
      value: percentage,
    };
  };

  const ratings = Object.entries(stats).filter(filterRatings).map(mapRatings);

  const orderRatings = _orderBy(ratings, ['rating'], ['desc']);

  const roundScore = _round(Number(score), 1);

  const transformed = {
    score: roundScore,
    total: total_review,
    ratings: orderRatings,
  };

  return transformed;
};
